import { Observable } from 'rxjs';
import { LoginDto } from '@base/models/login.dto';

export abstract class UserApiService {

  protected abstract get authEndpoint(): string;

  protected abstract submitLogin(email: string, password: string): Observable<LoginDto>;

  protected abstract requestPasswordReset(email: string): Observable<any>;

  protected abstract resetPassword(email: string, password: string): Observable<LoginDto>;
}
